import { Reducer } from 'redux';

import { PoolsState } from './types';

const defaultState: PoolsState = {
    poolsLoading: false,
    IPsLoading: false,
};
const reducer: Reducer<PoolsState> = (state: PoolsState = defaultState, action): PoolsState => {
    const { payload } = action;
    switch (action.type) {
        case '@@pools/FETCH_POOLS':
            return { ...state, ...{ poolsLoading: payload.poolsLoading } };
        case '@@pools/FETCH_POOLS_SUCCESS': {
            return { ...state, ...{ poolsLoading: payload.poolsLoading }, ...{ ipPools: payload.ipPools } };
        }
        case '@@pools/FETCH_POOLS_ERROR': {
            return { ...state, ...{ poolsLoading: false } };
        }
        case '@@pools/ADD_PURCHASE_INFO': {
            return { ...state, ...{ purchaseInfo: payload.purchaseInfo } };
        }
        case '@@pools/DELETE_PURCHASE_INFO': {
            const { purchaseInfo, ...restOfState } = state; //eslint-disable-line
            return { ...restOfState };
        }
        case '@@pools/LOAD_ALL_IPS':
            return { ...state, ...{ IPsLoading: true } };
        case '@@pools/MOVE_IP_TO_POOL_SUCCESS':
        case '@@pools/LOAD_ALL_IPS_SUCCESS':
            return { ...state, ...{ IPsLoading: false, IPs: payload.ips } };
        case '@@pools/DELETE_POOL_SUCCESS':
        case '@@pools/UPDATE_POOL_SUCCESS':
        case '@@pools/ADD_NEW_POOL_SUCCESS':
            return { ...state, ...{ ipPools: payload.ipPools } };

        default:
            return state;
    }
};

export { reducer as pools };

export default reducer;
